var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 48 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Exam") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,32 C26.6666667,29.6206897 32,28.0344828 32,22.8965517 C32,18.4137931 28.2,16 24.4,16 C20.7,16 17.4666667,18 16,21.5517241 L20.6,24.2758621 C21.2666667,22.6551724 22.3666667,21.3793103 24.2,21.3793103 C25.9,21.3793103 26.6666667,22.1724138 26.6666667,23.3793103 C26.6666667,26.4137931 21.3333333,27.9655172 21.3333333,32 L26.6666667,32 Z M24,42.6666667 C25.4596491,42.6666667 26.6666667,41.4596491 26.6666667,40 C26.6666667,38.5403509 25.4596491,37.3333333 24,37.3333333 C22.5403509,37.3333333 21.3333333,38.5403509 21.3333333,40 C21.3333333,41.4596491 22.5403509,42.6666667 24,42.6666667 Z M42.6666667,5.33333333 L31.52,5.33333333 C30.4,2.24 27.4666667,0 24,0 C20.5333333,0 17.6,2.24 16.48,5.33333333 L5.33333333,5.33333333 C4.96,5.33333333 4.61333333,5.36 4.26666667,5.44 C3.22666667,5.65333333 2.29333333,6.18666667 1.57333333,6.90666667 C1.09333333,7.38666667 0.693333333,7.97333333 0.426666667,8.61333333 C0.16,9.22666667 0,9.92 0,10.6666667 L0,48 C0,48.72 0.16,49.44 0.426666667,50.08 C0.693333333,50.72 1.09333333,51.28 1.57333333,51.7866667 C2.29333333,52.5066667 3.22666667,53.04 4.26666667,53.2533333 C4.61333333,53.3066667 4.96,53.3333333 5.33333333,53.3333333 L42.6666667,53.3333333 C45.6,53.3333333 48,50.9333333 48,48 L48,10.6666667 C48,7.73333333 45.6,5.33333333 42.6666667,5.33333333 Z M24,4.66666667 C25.0933333,4.66666667 26,5.57333333 26,6.66666667 C26,7.76 25.0933333,8.66666667 24,8.66666667 C22.9066667,8.66666667 22,7.76 22,6.66666667 C22,5.57333333 22.9066667,4.66666667 24,4.66666667 Z M42.6666667,48 L5.33333333,48 L5.33333333,10.6666667 L42.6666667,10.6666667 L42.6666667,48 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BF",
    transform: "translate(-440.000000, -1050.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(400.000000, 964.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon-Color",
    transform: "translate(8.000000, 2.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -2.666667)",
    id: "\\u21B3-Icon-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamIcon);
export default __webpack_public_path__ + "static/media/exam-icon.e60e2fbdbf923f089684325b36f0dfee.svg";
export { ForwardRef as ReactComponent };